import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'

interface IProps {
  size: number
  avatar?: string
}

export const RainbowAvatar = ({ size, avatar }: IProps) => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.rainbow,
        borderRadius: '50%',
        p: '2px',
        minWidth: size,
        maxWidth: size,
        minHeight: size,
        maxHeight: size,
      }}
    >
      <Avatar
        sx={{
          width: size,
          height: size,
          background: (theme) => theme.palette.background.default,
        }}
      >
        <Typography fontSize={size / 2}>{avatar}</Typography>
      </Avatar>
    </Box>
  )
}
